import React, { Component } from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import ExportButton from 'components/Export';
import ListHeader from 'components/List/Header';
import ListRow from 'components/List/Row';
import PointOfSales from 'components/PointOfSales';
import ShowMoreButton from 'components/ShowMoreButton';

const isMobile = window.innerWidth <= 845;

const TravelPosCardContainer = styled.div`
  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .alignExport {
    margin-top: 5px;
  }

  .ttTitle {
    @media (max-width: 845px) {
      font-size: 16px;
    }
  }

  .ttTitle span {
    color: #e25c32;
    margin-right: 10px;
  }

  .cardContent {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: flex-start;
  }

  .tableContainer {
    width: 50%;
    color: ${(props) => props.theme.colors.dark};
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
  }

  .client-row li {
    background-color: ${(props) => props.theme.colors['terra-cotta']};

    .rankRowItem p,
    .wineRowItem p,
    .nbRestaurantRowItem p {
      color: white;
    }
  }

  .rankRowItem {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: ${(props) => props.theme.colors.dark};
    font-weight: 600;
    width: 15%;
    justify-content: center;

    @media (max-width: 845px) {
      width: 100%;
    }

    p {
      color: ${(props) => props.theme.colors.dark};
      margin-left: 20px;

      @media (max-width: 845px) {
        margin-left: 0;
        justify-content: center;
        display: flex;
        width: 100%;
      }
    }
  }

  .wineRowItem {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: ${(props) => props.theme.colors.dark};
    font-weight: 600;
    width: calc(60% - 27px);

    @media (max-width: 845px) {
      width: 100%;
    }

    p {
      color: ${(props) => props.theme.colors.dark};
      margin-left: 20px;

      @media (max-width: 845px) {
        margin-left: 0;
        justify-content: center;
        display: flex;
        width: 100%;
        text-align: center;
        padding: 0 5px;
      }
    }
  }

  .nbRestaurantRowItem {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: ${(props) => props.theme.colors.dark};
    width: calc(25% - 27px);

    @media (max-width: 845px) {
      width: 100%;
    }

    p {
      color: ${(props) => props.theme.colors.dark};
      margin-left: 20px;

      @media (max-width: 845px) {
        margin-left: 0;
        justify-content: center;
        display: flex;
        width: 100%;
      }
    }
  }

  .showAllContainer {
    margin-left: auto;
    margin-right: auto;
    width: 200px;

    @media (max-width: 845px) {
      width: 100%;
    }
  }

  .totalRow {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    color: white !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    width: 100%;

    @media (max-width: 845px) {
      display: grid;
      grid-template-columns: 1fr 2fr 2fr;
    }

    > div {
      display: flex;
    }

    .rankRowItem p,
    .wineRowItem p,
    .nbRestaurantRowItem p {
      color: white;
    }
  }

  .posListContainer {
    height: 100%;
  }

  .tlgContentContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    @media (max-width: 1200px) {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 1200px) {
    .cardContent {
      flex-direction: column;
      justify-content: center;
    }

    .cardContent > :not(:last-child) {
      margin-bottom: 20px;
    }

    .tableContainer {
      width: 100%;
    }

    .posListContainer {
      margin-left: 0%;
      width: 100%;
    }
  }

  .posList {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;
    display: grid;

    @media screen and (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      grid-template-columns: 1fr;
    }
  }

  .tpcPosContainer {
    width: 45%;
    margin-left: auto;

    h1 {
      font-size: 20px;
      text-transform: uppercase;
      color: #1e1f1e;
      font-family: ${(props) => props.theme.fonts.oswald};
    }
  }

  .tcpPosHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: -100px;
    margin-bottom: 45px;
  }

  .tcpPosExport {
    margin-left: auto;
    z-index: 2;
  }

  .content {
    gap: 20px;
    display: flex;
    flex-direction: column;
  }

  .right-content-header {
    // height of the extra from the left container
    margin-bottom: 36px;

    @media (max-width: 845px) {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1200px) {
    .tpcPosContainer {
      width: 100%;
      margin-left: 0;

      .tcpPosHeader {
        margin-top: 20px;
        margin-bottom: 20px;
      }

      h1 {
        font-size: 20px;
        text-transform: uppercase;
        color: #1e1f1e;
        font-family: ${(props) => props.theme.fonts.oswald};
      }
    }
  }

  @media (max-width: 1305px) and (min-width: 1200px) {
    .ttTitle {
      max-width: 98%;
      word-break: break-word;
      white-space: normal;
    }

    .tpcPosContainer {
      max-width: 40%;
    }

    .tpcPosContainer h1 {
      margin-top: -110px;
    }
  }
`;

class TravelPosCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverExport: false,
      showAll: false,
      sorted: null,
      sortAscending: false
    };
  }

  renderHeaderLeftContent() {
    const { type, title = '', exportOptions, exportName } = this.props;

    return (
      <CardHeader
        title={<div className="ttTitle">{title}</div>}
        tooltip={
          !isMobile
            ? {
                placement: 'top',
                tooltipContentStyles: `max-width:500px;padding:20px;font-family:SFCompactText;font-size:12px;line-height:1.5`,
                content:
                  'Il peut arriver que selon vos préférences, vous n’ayez pas votre marque ou une de vos marques concurrentes composée du même panel de vins que la marque Wine Services, dans ce cas les nombres de restaurants distribuant ces marques pourraient différer de vos autres rapports.'
              }
            : null
        }
        rightComponents={
          <ExportButton
            jpg
            pdf
            xls
            {...exportOptions}
            path={exportOptions.pathWine}
            name={`${exportName} +${type}-${type}`}
            targetElement={`#voyage-classement-${type}`}
            newApi
          />
        }
        fontSize="20px"
        iconColor="#e25c32"
        iconRight
      />
    );
  }

  renderHeaderRightContent() {
    const { type, title = '', exportOptions, exportName } = this.props;
    return (
      <CardHeader
        title={
          <div className="ttTitle">
            {I18n.t('travel.titlePos1') !== 'titlePos1'
              ? I18n.t('travel.titlePos1') + ' '
              : ''}
            {type} {I18n.t('travel.titlePos2')}
          </div>
        }
        rightComponents={
          <ExportButton
            jpg
            pdf
            xls
            {...exportOptions}
            path={exportOptions.pathPos}
            name={`${exportName} +${title}-${type}`}
            targetElement={`#voyage-pos-${type}`}
            newApi
          />
        }
        fontSize="20px"
        iconColor="#e25c32"
        iconRight
      />
    );
  }

  renderTable(subSetData) {
    const { retractedSize, dataTable, type } = this.props;
    const { showAll } = this.state;
    const clientRows = dataTable.filter((item) => item.is_client);

    return (
      <div>
        <ListHeader
          columns={[
            {
              length: !isMobile ? '15%' : 'none',
              name: I18n.t('travel.rankColumns.rank'),
              center: true
            },
            {
              length: !isMobile ? 'calc(60% - 27px)' : 'none',
              name: I18n.t('travel.rankColumns.wines'),
              center: isMobile
            },
            {
              length: !isMobile ? 'calc(25% - 27px)' : 'none',
              name: I18n.t('travel.rankColumns.distribution'),
              center: isMobile
            }
          ]}
        />
        {subSetData.map((row, index) => (
          <div
            key={`row-${index}`}
            className={row.is_client ? 'client-row' : ''}
          >
            <ListRow dark={index % 2 === 0}>
              <div className="rankRowItem">
                <p>{row.rank}</p>
              </div>
              <div className="wineRowItem">
                <p>{row.name}</p>
              </div>
              <div className="nbRestaurantRowItem">
                <p>
                  {row.dn} {type}
                </p>
              </div>
            </ListRow>
          </div>
        ))}
        {clientRows &&
          clientRows.length > 0 &&
          clientRows[0].rank > retractedSize &&
          !showAll && (
            <div className="totalRow">
              <div className="rankRowItem">
                <p>{clientRows[0].rank}</p>
              </div>
              <div className="wineRowItem">
                <p>{clientRows[0].name}</p>
              </div>
              <div className="nbRestaurantRowItem">
                <p>
                  {clientRows[0].dn} {type}
                </p>
              </div>
            </div>
          )}
      </div>
    );
  }

  renderPosList() {
    const { dataPos } = this.props;
    return (
      <div className="posList">
        {dataPos.map((pos, index) => {
          return (
            <PointOfSales
              {...pos}
              key={`${pos.name}-${index}`}
              references_total={pos.wines_total}
            />
          );
        })}
      </div>
    );
  }

  renderButtonShowMore() {
    const { dataTable, retractedSize } = this.props;
    if (dataTable.length <= retractedSize) {
      return null;
    }

    const { showAll } = this.state;
    if (showAll) {
      // show less
      return (
        <ShowMoreButton
          label={`${I18n.t('travel.seeLess')} (${retractedSize})`}
          onClick={() => this.setState({ showAll: false })}
        />
      );
    }

    // show more
    return (
      <ShowMoreButton
        label={`${I18n.t('travel.seeMoreRank')} (+${
          dataTable.length - retractedSize
        })`}
        onClick={() => this.setState({ showAll: true })}
      />
    );
  }

  render() {
    const { name, dataTable, retractedSize } = this.props;

    const { showAll } = this.state;
    let subSetData = showAll ? dataTable : dataTable.slice(0, retractedSize);

    return (
      <TravelPosCardContainer>
        <div className="content-grid tlgContentContainer">
          <Card
            id={`travel-classement-${name}-1`}
            className="content left-content"
          >
            {this.renderHeaderLeftContent()}
            {this.renderTable(subSetData)}{' '}
            <div className="showAllContainer ignored-export">
              {this.renderButtonShowMore()}
            </div>
          </Card>
          <Card
            id={`travel-classement-${name}-1`}
            className="content right-content"
          >
            <div className="right-content-header">
              {this.renderHeaderRightContent()}
            </div>
            <div className="posListContainer">{this.renderPosList()}</div>
          </Card>
        </div>
      </TravelPosCardContainer>
    );
  }
}

export default TravelPosCard;
